<template>
  <div class="container">
    <div class="info">
      <!-- 修改登录密码 -->
      <div class="title">{{ $t('safe').ChangeLoginPassword }}</div>
      <div class="content">
        <!-- 旧密码 -->
        <van-field v-model="oldPassword" :type="oldpsdType" :placeholder="$t('upPassword').oldPasswordMsg"
          :right-icon="oldpsdType === 'password' ? 'eye' : 'closed-eye'"
          @click-right-icon="oldpsdType = oldpsdType === 'password' ? 'text' : 'password'">
        </van-field>
        <!-- 新密码 -->
        <van-field v-model="Password" :type="psdType" :placeholder="$t('upPassword').newPasswordMsg"
          :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'"
          @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
        </van-field>
        <!-- 确认密码 -->
        <van-field v-model="twoPassword" :type="twopsdType" :placeholder="$t('upPassword').twoPasswordMsg"
          :right-icon="twopsdType === 'password' ? 'eye' : 'closed-eye'"
          @click-right-icon="twopsdType = twopsdType === 'password' ? 'text' : 'password'">
        </van-field>
        <!-- 按钮 -->
        <van-button block @click="handleSub">{{ $t('upPassword').btn }}</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  data() {
    return {
      oldPassword: '',//原密码
      Password: '',//新密码
      twoPassword: '',//确认密码
      oldpsdType: "password", //输入框类型
      psdType: "password", //输入框类型
      twopsdType: "password", //输入框类型
    }
  },
  computed: {
    ...mapGetters(['basicConfig'])
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    // 提交
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        oldPassword: this.oldPassword,
        newPassword: this.Password,
      }
      await userApi.upMemberPassword(form)
      this.$toast({ message: this.$t('upPassword').submsg })
      this.$router.go(-1)
    },
    checkForm() {
      if (!this.oldPassword) {
        this.$toast({ message: this.$t('upPassword').oldPasswordMsg })
        return false
      }
      if (!this.Password) {
        this.$toast({ message: this.$t('upPassword').newPasswordMsg })
        return false
      }
      if (!this.twoPassword) {
        this.$toast({ message: this.$t('upPassword').twoPasswordMsg })
        return false
      }
      if (this.Password !== this.twoPassword) {
        this.$toast({ message: this.$t('upPassword').twoinputMsg })
        return false
      }
      return true
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 110px;
  padding-bottom: 80px;
  width: 100%;
  background: var(--background_color);

  .info {
    margin: 0 auto;
    max-width: 480px;

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .content {
      margin-top: 30px;

      .van-button {
        margin-top: 30px;
        background: var(--text_color);
        height: 50px;
        border-radius: 25px;
        border: 0;
        font-size: 16px;
        color: var(--background_color);
      }

      .van-button:hover {
        opacity: 0.8;
      }
    }
  }
}


::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 50px;
  margin-bottom: 30px;
  border-radius: 10px;
  font-size: 15px;
  border: 1px solid var(--ntext_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 15px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}
</style>
